import CarouselSkeletonComponent from "./CarouselSkeleton";
import CardContentSkeletonComponent from "./CardContentSkeleton";
import LocationSkeletonComponent from "./LocationSection";

export const CarouselSkeleton = CarouselSkeletonComponent
export const CardContentSkeleton = CardContentSkeletonComponent
export const LocationSkeleton = LocationSkeletonComponent